import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { getPortalPath } from '../utils/roleRedirect';
import { Box, CircularProgress } from '@mui/material';

/**
 * StudentOnlyRoute — allows unauthenticated visitors (public access)
 * but redirects authenticated non-student users to their own dashboard.
 */
function StudentOnlyRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Not logged in → allow (public access)
  if (!user) return children;

  // Student → allow
  if (user.role === 'student') return children;

  // Any other role → redirect to their dashboard
  return <Navigate to={getPortalPath(user.role)} replace />;
}

export default StudentOnlyRoute;
